import { TrazabilityEntity } from '@private/modules/cash-out-payment/core/entities/trazability.entity';
import { environment } from '@environments/environment';
import { LoginUrlBuilderConfig } from '@shared/services/login-url-builder/login-url-builder.config';

export class LoginUrlBuilder {

  public build(loginState: string, trazability: TrazabilityEntity): string {

    const params = new URLSearchParams({
      [ LoginUrlBuilderConfig.loginState ]: loginState,
      [ LoginUrlBuilderConfig.servicePath ]: environment.apiServices.biocatchUrl,
      [ LoginUrlBuilderConfig.trazabilityCode ]: trazability.trazabilityCode,
      [ LoginUrlBuilderConfig.ticketId ]: trazability.ticketId,
    }).toString();

    return `${ window.location.origin }${ LoginUrlBuilderConfig.publicAuthRoute }?${ params }`;
  }
}
